var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJobPostIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9077 21.9016H9.3655C5.422 21.9016 3.4508 21.9016 2.2254 20.6531C1 19.4046 1 17.3949 1 13.3766C1 9.35826 1 7.34856 2.2254 6.10006C3.4508 4.85156 5.422 4.85156 9.3655 4.85156H13.5488C17.4923 4.85156 19.4646 4.85156 20.69 6.10006C21.6327 7.06036 21.8494 8.47166 21.9 10.9016",
    stroke: "#F1EAE0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8187 20.8253L23 23M16.4 4.85L16.29 4.509C15.7455 2.815 15.4738 1.968 14.8259 1.484C14.1769 1 13.3167 1 11.593 1H11.3037C9.5822 1 8.7209 1 8.073 1.484C7.424 1.968 7.1523 2.815 6.6078 4.509L6.5 4.85M21.9583 18.0786C21.967 17.5637 21.873 17.0522 21.682 16.574C21.4909 16.0957 21.2066 15.6603 20.8455 15.2931C20.4844 14.9259 20.0539 14.6343 19.5789 14.4352C19.104 14.2361 18.5941 14.1336 18.0791 14.1336C17.5642 14.1336 17.0543 14.2361 16.5794 14.4352C16.1044 14.6343 15.6739 14.9259 15.3128 15.2931C14.9517 15.6603 14.6674 16.0957 14.4763 16.574C14.2853 17.0522 14.1913 17.5637 14.2 18.0786C14.2171 19.0961 14.6334 20.0661 15.359 20.7796C16.0846 21.4931 17.0615 21.893 18.0791 21.893C19.0968 21.893 20.0737 21.4931 20.7993 20.7796C21.5249 20.0661 21.9412 19.0961 21.9583 18.0786Z",
    stroke: "#F1EAE0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobPostIcon);
export default __webpack_public_path__ + "static/media/jobPostIcon.a6308af1089da2ae1d9dadf83b97d094.svg";
export { ForwardRef as ReactComponent };